//import bridge from "@vkontakte/vk-bridge";

import { updateUserStateParams } from '../../app/store/userReducer';
import { setRouteName } from '../../app/store/routerReducer';
import { ROUTE_RESULT } from '../../app/router';

export const calculateThunk = () => {

    return (dispatch, getState) => {

        let state = getState();
        let birthDay = parseInt(state.user.birthDayInput, 10) || 0;
        let birthMonth = parseInt(state.user.birthMonthInput, 10) || 0;
        let birthYear = parseInt(state.user.birthYearInput, 10) || 0;

        // TODO: Check 4-digit year?

        let arkanes = [
            0,
            normalize(birthDay),
            normalize(birthMonth),
        ];

        arkanes[3] = normalize( String(birthYear).split('').reduce((acc, currentVal) => (acc + parseInt(currentVal, 10)), 0) );
        arkanes[4] = normalize(arkanes[1] + arkanes[2]);
        arkanes[5] = normalize(arkanes[2] + arkanes[3]);
        arkanes[6] = normalize(arkanes[4] + arkanes[5]);
        arkanes[7] = normalize(arkanes[1] + arkanes[4]);
        arkanes[8] = normalize(arkanes[2] + arkanes[4]);
        arkanes[9] = normalize(arkanes[2] + arkanes[5]);

        // tmp
        arkanes[10] = 1;
        arkanes[11] = 1;
        arkanes[12] = 1;
        arkanes[13] = 1;
        arkanes[14] = 1;
        arkanes[15] = 1;

        //console.log('arkanes', arkanes);

        // NEW. * - добавить в стор

        // Возраст души – самая большая цифра из цветных
        let soulAge = Math.max(arkanes[1], arkanes[2], arkanes[3], arkanes[4], arkanes[5], arkanes[6]);
        console.log('soulAge', soulAge);

        // Внутренний ребенок *
        let innerChild = arkanes[8];
        // console.log('innerChild', innerChild);

        // Долгосрочная карма
        let longKarmaArr = [ arkanes[4] ];
        let longKarmaRaw = [ arkanes[1], arkanes[2], arkanes[3], arkanes[5], arkanes[6] ];
        let longKarmaAcc = [];
        longKarmaRaw.forEach((item) => {
            if ( longKarmaAcc.includes(item) && !longKarmaArr.includes(item) ) {
                longKarmaArr.push(item);
            }
            longKarmaAcc.push(item);
        });
        let longKarma = longKarmaArr.join(', ');
        console.log('longKarma', longKarma);
        // !!! Может быть другой !!! Надо выяснить, как именно (позиции 1-6 включтельно)


        // OLD
        // Синие цифры = сумма цифр, выделенных треугольником
        let innerArkanes = [
            normalize( arkanes[9] + arkanes[10]+ arkanes[11] ),
            normalize( arkanes[1] + arkanes[2]+ arkanes[4] ),
            normalize( arkanes[2] + arkanes[3]+ arkanes[5] ),
            normalize( arkanes[2] + arkanes[4]+ arkanes[5] ),
            normalize( arkanes[4] + arkanes[5]+ arkanes[6] ),
        ];

        //console.log('innerArkanes', innerArkanes);

        /*
        let arkanesMaleDigits = [1, 4, 5, 7, 11, 15, 19];
        let arkanesFemaleDigits = [2, 3, 8, 13, 17, 18];
        let arkanesNeutralDigits = [6, 9, 10, 12, 14, 16, 20, 21, 22];
        
        let arkanesDigits = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22].map((item)=>{
            if (arkanesMaleDigits.includes(item)) return 'm';
            if (arkanesFemaleDigits.includes(item)) return 'f';
            if (arkanesNeutralDigits.includes(item)) return 'n';
            return 'u';
        });
        console.log(arkanesDigits);
        */
        let arkanesDigits = ["u","m","f","f","m","m","n","m","f","n","n","m","n","f","n","m","n","f","f","m","n","n","n"];
        let genderArkanes = { u: 0, m: 0, f: 0, n: 0 };
        let digitsCount = new Array(23).fill(0);
        
        let circleArkanes = [ arkanes[4], arkanes[1], arkanes[2], arkanes[3], arkanes[5], arkanes[6] ];     // arkanes[4] - always RED
        //console.log('circleArkanes', circleArkanes);

        circleArkanes.forEach((item) => {
            genderArkanes[ arkanesDigits[item] ]++;     // Male, Female, Neutral Arkanes
            digitsCount[item]++;
        });

        //console.log('genderArkanes', genderArkanes);
        //console.log('digitsCount', digitsCount);

        // Возраст души – самая большая цифра из этого места (circleArkanes), среди ЧЁРНЫХ цифр circleArkanes[0] - always RED
        /*
        let soulAge = 0;
        circleArkanes.slice().forEach((item) => {
            //if ( item > soulAge && digitsCount[item] < 2) {
            // fix: все, а не только черные
            if ( item > soulAge ) {
                soulAge = item;
            }
        });
        //console.log('soulAge', soulAge);
        */

        // Male/Female Enegry and Karmic
        //                  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22
        let maleEnergy =   [0, 1, 0, 0, 2, 2, 0, 1, 0, 0,  0,  1,  0,  0,  0,  1,  0,  0,  0,  2,  0,  0,  0];
        let femaleEnergy = [0, 0, 2, 2, 0, 0, 0, 0, 1, 0,  0,  0,  0,  1,  0,  0,  0,  1,  2,  0,  0,  0,  0];
        let karmic =       [0, 0, 0, 0, 0, 0, 0, 0, 1, 0,  1,  0,  0,  0,  0,  0,  1,  0,  0,  0,  1,  0,  0]
        let energyArkanes = { m: 0, f: 0, k: 0 };
        circleArkanes.forEach((item) => {
            energyArkanes.m += maleEnergy[item];
            energyArkanes.f += femaleEnergy[item];
            energyArkanes.k += karmic[item];
        });

        //console.log('energyArkanes', energyArkanes);

        // Flipped Arkanes - 11 & 4 - always flipped, but 11 not influence on male/female energy
        let flippedArkanes = [ arkanes[4] ];
        digitsCount.forEach((count, digit) => {
            if ( count > 1 ) {
                flippedArkanes.push(digit);
            }
        });
        //console.log('flippedArkanes', flippedArkanes);
        let arkanesMaleDigits = [1, 4, 5, 7, 11, 15, 19];
        let arkanesFemaleDigits = [2, 3, 8, 13, 17, 18];
        let maleIsFlipped = false;
        let femaleIsFlipped = false;
        flippedArkanes.forEach((item) => {
            if (arkanesMaleDigits.includes(item)) {
                maleIsFlipped = true;
            }
            if (arkanesFemaleDigits.includes(item)) {
                femaleIsFlipped = true;
            }
        });

        dispatch(updateUserStateParams({
            birthDay: birthDay,
            birthMonth: birthMonth,
            birthYear: birthYear,
            arkanes: arkanes,
            innerArkanes: innerArkanes,
            soulAge: soulAge,
            innerChild: innerChild,
            longKarma: longKarma,
            genderArkanes: genderArkanes,
            energyArkanes: energyArkanes,
            digitsCount: digitsCount,
            maleIsFlipped: maleIsFlipped,
            femaleIsFlipped: femaleIsFlipped,
        }));

        dispatch(setRouteName(ROUTE_RESULT));

        /*
        if (state.app.searchParams && state.app.searchParams.vk_platform && state.app.searchParams.vk_platform === "desktop_web") {
            bridge.send("VKWebAppResizeWindow", {
                "width": 700,
                "height": 700,
            }).then((data) => {
                // Обработка события в случае успеха
                //console.log('VKWebAppResizeWindow res', data);
            })
            .catch((error) => {
                // Обработка события в случае ошибки
                console.log('VKWebAppResizeWindow error', error);
            });
        }
        */
    }
}

export const normalize = (num) => {
    if ( num == 0) {
        return 22;
    }
    if ( num <= 22 ) {
        return num;
    } else {
        return normalize( num - 22 );
    }
}